export default __webpack_public_path__ + "static/media/45_whale.2f9b2508.JPG";